import { Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import * as S from './style';

function SpentToDateModal({ isCCPayment, isModalOpen, onModalOpen }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={onModalOpen}
      title={t('spentToDate')}
      primaryButtonProps={{
        children: t('okay'),
        onClick: onModalOpen
      }}
      size="sm"
    >
      <S.Col>
        <Typography variant="body2">
          <Trans i18nKey="spentToDateModalDesc1" components={{ b: <b /> }} />
        </Typography>
        <Typography variant="body2">
          {isCCPayment ? (
            <Trans i18nKey="spentToDateModalDesc2CC" components={{ b: <b /> }} />
          ) : (
            <Trans i18nKey="spentToDateModalDesc2HA" components={{ b: <b /> }} />
          )}
        </Typography>
      </S.Col>
    </Modal>
  );
}

export { SpentToDateModal };
